import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class SessionExpiryInterceptor implements HttpInterceptor {
    private readonly UNAUTH_CODE = 401;

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === this.UNAUTH_CODE) {
                    const errorBody = error.error;
                    if (errorBody && errorBody.error === 'session_expired') {
                        window.location.href =
                            document.getElementsByTagName('base')[0].href + '?session_expired=true';
                        return EMPTY;
                    }
                    return throwError(() => error);
                }
                return throwError(() => error);
            })
        );
    }
}
